/**
 * 「这个时长档装得下多少」提示行(2026-08-19 老板走查:「15s 推荐 1-2 个卖点,30s 如何推荐」)。
 *
 * ★2026-09-13 A1:从 `VideoFormatRow` 抽成共享行 —— 时长主入口挪进「时长×拍法 联动卡」后,
 *   联动卡与(蓝图/幕二/未选目的的)画面层两处都要渲这句,措辞/testid 必须**单一源**,
 *   否则两处各写一遍、哪天只改一处就两套说法。数值口径见 `shotBudget.ts`(与 ai 侧同公式)。
 */
import { durationAdvice } from "../../model/shotBudget";
import { cn } from "@/shared/lib/utils";

interface Props {
  /** 目标总秒数(briefTargetSec 的结果);无值 → 不渲染(别对着空档编数字)。 */
  targetSec?: number | null;
  /** 引擎节拍表的内容位数(taxonomy 给了才有);给了就用真值,否则回退经验值。 */
  contentBeats?: number | null;
  className?: string;
}

export function DurationAdviceLine({ targetSec, contentBeats, className }: Props) {
  const advice = durationAdvice(targetSec, contentBeats);
  if (!advice) return null;
  return (
    <p
      data-testid="duration-advice"
      className={cn("mt-1 max-w-[22rem] text-2xs leading-snug text-muted-foreground/80", className)}
    >
      这个档大约 {advice.shots[0]}~{advice.shots[1]} 镜、口播上限约 {advice.chars}{" "}
      字(超出会被裁掉) ——{" "}
      {advice.points[0] === advice.points[1] ? (
        /* 真值(来自引擎节拍表的内容位数):给确定数,用户才敢照着写 */
        <>
          这套叙事有 {advice.points[0]} 个内容位,讲 {advice.points[0]}{" "}
          个卖点/产品最稳,讲太多每个都说不透。
        </>
      ) : (
        <>建议讲 {advice.points[0]}~{advice.points[1]} 个卖点/产品,讲太多每个都说不透。</>
      )}
    </p>
  );
}
